export const TRUSTED = "trusted";
export const UNTRUSTED = "untrusted";
export const PAT_TO_HCP = "pat-to-hcp";